import * as React from "react";
import PropTypes from 'prop-types';

const SvgVideoNew = props => {
  if (props.id !== "_svgvideonew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 28 28" {...props}><g fill="none" fillRule="evenodd"><circle fillOpacity={0.8} fill="#FFF" cx={14} cy={14} r={14} /><path d="M20.66 13.487L9.942 7.975a.966.966 0 00-.789-.03c-.25.103-.405.303-.404.521l.04 11.07c0 .219.157.419.407.52a.956.956 0 00.789-.032l10.677-5.558c.211-.11.338-.294.337-.49 0-.197-.128-.38-.34-.489" stroke="#727272" /></g></svg>;
};

SvgVideoNew.displayName = "_svgvideonew";
SvgVideoNew.propTypes = {
  id: PropTypes.string
};
SvgVideoNew.defaultProps = {
  id: ''
};
export default SvgVideoNew;